import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import navigateToOptionLink from '../actions/navigateToOptionLink';

export default function FullOptionsLink({
    children,
    category,
    subcategory,
    option,
}: {
    children: React.ReactNode;
    category: string;
    subcategory: string;
    option?: string;
}) {
    const onClick = () => {
        navigateToOptionLink(category, subcategory, option);
    };

    return (
        <Link style={{ fontSize: 14 }} onClick={onClick}>
            {children}
        </Link>
    );
}
